import React from 'react';
import './styles/om.css';
import LoneImage from '../images/Lone.jpg';
import { FaHandshake, FaLightbulb, FaChartLine, FaUsers } from 'react-icons/fa';
import CTAButton from '../components/CTAButton';
import ContactForm from '../components/contactForm';
import omHero from '../images/image1.jpg';
import { FaCog, FaTools, FaShieldAlt } from 'react-icons/fa';

function Om() {
  return (
    <>
      <div className="om-hero">
        <img src={omHero} alt="Om Byggeriets Partner" className="om-hero-image" />
      </div>

      <section className="om-intro">
        <div className="om-container">
          <div className="om-intro-grid">
            <div className="om-intro-content">
              <h2>Erfaring møder innovation</h2>
              <p className="om-intro-text">
                Byggeriets Partner blev etableret af Lone Frederiksen med over 20 års erfaring i byggebranchen. Gennem årene har jeg fulgt udviklingen på tæt hold og set, hvordan dokumentationskravene er steget markant.
              </p>
              <p className="om-intro-text">
                I det stigende dokumentationskrav i byggebranchen fandt jeg min motivation til at etablere min virksomhed. Mit mål er at hjælpe virksomheder med at håndtere disse krav effektivt og værdiskabende.
              </p>
            </div>
            <div className="om-image-container">
              <img src={LoneImage} alt="Lone Frederiksen" className="om-image" />
            </div>
          </div>
        </div>
      </section>

      <section className="om-values">
        <div className="om-container">
          <div className="om-values-grid">
            <div className="om-value-card">
              <FaHandshake className="om-icon" />
              <h3>Partnerskab</h3>
              <p>Vi arbejder tæt sammen med vores kunder for at finde de løsninger, der passer bedst til deres behov og udfordringer.</p>
            </div>
            <div className="om-value-card">
              <FaLightbulb className="om-icon" />
              <h3>Ekspertise</h3>
              <p>Med over 20 års erfaring i branchen sikrer vi professionel rådgivning inden for kvalitetssikring og drift & vedligehold.</p>
            </div>
            <div className="om-value-card">
              <FaChartLine className="om-icon" />
              <h3>Udvikling</h3>
              <p>Vi holder os opdateret med de nyeste standarder og krav, herunder DS1140, for at sikre optimal værdi for vores kunder.</p>
            </div>
            <div className="om-value-card">
              <FaUsers className="om-icon" />
              <h3>Landsdækkende</h3>
              <p>Fra vores kontor nær Svebølle ved Kalundborg samarbejder vi med byggebranchens aktører i hele Danmark.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="om-mission">
        <div className="om-container">
          <div className="om-mission-content">
            <h2>Vores mission</h2>
            <p>
              Som din partner i dokumentation er vores mål at sikre, at kvalitetssikring og drift & vedligehold bliver et værdifuldt redskab - ikke en byrde. Vi specialiserer os i at hjælpe virksomheder med indsamling og digitalisering af kvalitetssikring samt drift & vedligehold, herunder DS1140.
            </p>
            <div className="om-cta">
              <CTAButton text="Tag første skridt" to="/kontakt" />
            </div>
          </div>
        </div>
      </section>

      <section className="drift-section">
        <div className="section-content">
          <div className="contact-section">
            <div className="contact-content">
              <div className="contact-header">
                <span className="overline">Kontakt os</span>
                <h3>Lad os tale om jeres behov</h3>
                <p className="contact-intro">
                  Vi hjælper jer med at optimere jeres byggeprojekter gennem professionel kvalitetssikring og drift & vedligehold.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Om;
